import React from 'react';
import {
	FilteringState,
	IntegratedFiltering,
	SelectionState,
} from '@devexpress/dx-react-grid';
import {
	Grid, VirtualTable, TableSelection, TableFilterRow
} from '@devexpress/dx-react-grid-material-ui';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

class FamousRacesList extends React.Component {

	componentDidUpdate(prevProps, prevState, snapshot) {
		console.log('FAMOUSRACES ' + this.props.data.famousRaces.length + ' ' + this.props.data.selectedFamousIndices.length)
		if (this.props.data.famousRaces && this.props.data.famousRaces.length > 0) {
			if (this.props.data.selectedFamousIndices.length === 0) {
				this.handleRowSelection([Math.floor(Math.random() * this.props.data.famousRaces.length)])
			}
		} else {
			this.props.onSelectFamousActivities([this.props.data.famousRaces[8]], [8]);

			this.props.onFetchFamousRace(2474);

			const { onChangeLabel } = this.props;
			onChangeLabel("title", "Marseille");
			onChangeLabel("subtitle", "2019-03-24 8:00");
			onChangeLabel("calculatedDistance", 42.195);
		}
	}

	handleRowSelection = (selectedRows) => {
		console.log(selectedRows);
		var selectedRow;
		if (selectedRows.length > 1) { selectedRow = selectedRows[1] }
		if (selectedRows.length === 1) { selectedRow = selectedRows[0] }


		if (selectedRows.length > 0) {

			//if (this.props.poster.template === 'singleRouteMap' ) {

			//Single selection
			console.log('singleSelection');
			this.props.onSelectFamousActivities([this.props.data.famousRaces[selectedRow]], [selectedRow]);

			let activity = this.props.data.famousRaces[selectedRow];

			this.props.onFetchFamousRace(activity.id);

			const { onChangeLabel } = this.props;
			onChangeLabel("title", activity.name);
			onChangeLabel("subtitle", moment(activity.start_date).format('YYYY-MM-DD HH:mm'));
			let dist = (activity.distance / 1000).toFixed(3)
			onChangeLabel("calculatedDistance", dist);

			//} else {
			//Mulitple selection
			/*console.log('multipleSelection');
			let activities = this.props.data.activities;
			let selectedActivities = selectedRows.map(function (val, index) {
				return activities[val];
			});
			this.props.onSelectActivities(selectedActivities, selectedRows);

			let activity = selectedActivities[0];

			const { onChangeLabel } = this.props;
			onChangeLabel("title", activity.name);
			onChangeLabel("subtitle", moment(activity.start_date).format('YYYY-MM-DD HH:mm'));

			let sum = selectedActivities.reduce(function (prev, cur) {
				return { distance: prev.distance + cur.distance };
			})
			let sumTime = selectedActivities.reduce(function (prev, cur) {
				return { elapsed_time: prev.elapsed_time + cur.elapsed_time };
			})
			let dist = (sum.distance / 1000).toFixed(1)
			onChangeLabel("calculatedDistance", dist);*/
			//}

		} else {
			this.props.onSelectFamousActivities([], []);
		}


	}


	render() {


		return (
			<div style={{ position: 'relative' }}>
				{this.props.data.isFetching && <div style={{ backgroundColor: 'rgba(255,255,255,.8)', position: 'absolute', zIndex: 1000, left: 0, width: '100%', height: '100%', textAlign: 'center' }}><CircularProgress style={{ position: 'absolute', top: '45%', left: '45%' }} size={100} thickness={2} /></div>}
				<Typography style={{ margin: 20 }}>
					If you don't have a Strava account or wish to offer a poster to a sportive friend, famous <b>races</b> are for you!
					Pick one and customize it.<br /> Races can only be used with the <i>Single route map</i> template.
				</Typography>
				{this.props.poster.template === 'singleRouteMap' && <Grid disabled={true}
					rows={this.props.data.famousRaces.map((obj, i) => {
						return { name: obj.name }
					})
					}
					columns={[
						{ name: 'name', title: 'Name' }
					]}>
					<SelectionState
						selection={this.props.data.selectedFamousIndices}
						onSelectionChange={this.handleRowSelection}
					/>
					{/*<IntegratedGrouping/>*/}

					<FilteringState defaultFilters={[]} />
					<IntegratedFiltering />
					<VirtualTable color="primary" height={this.props.poster.layout.height - 230} />
					<TableSelection
						showSelectionColumn={false}
						selectByRowClick
						highlightRow />
					<TableFilterRow />

					{/*<TableGroupRow cellComponent={RxMyGroupCell}></TableGroupRow>*/}
				</Grid>}

			</div>
		)
	}
}

export default FamousRacesList;


// WEBPACK FOOTER //
// ./src/components/FamousRacesList.js